module.exports = __webpack_public_path__ + "img/top2.d5301f57.png";